import { PAYMENT_CONFIG } from "../../Payment/paymentConstants";

function getPaymentMethodIcon(payment_key) {
    const config = PAYMENT_CONFIG[payment_key];
    return config?.fullIcon || config?.icon || 'IcPaymentMethod';
}

export default getPaymentMethodIcon;
